define('view/template/template.detail.page.view',['require','exports','module','underscore','marionette','blockit','formkit/formkit','uikit/uikit','backbone.radio','fukit','fukit','fukit','behavior/model.lock.behavior','model/lock.model','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                                             = require('underscore'),
      Mn                                            = require('marionette'),
      BlocKit                                       = require('blockit'),
      FormKit                                       = require('formkit/formkit'),
      UIKit                                         = require('uikit/uikit'),
      Radio                                         = require('backbone.radio'),
      EnableOnlyOnUnsavedChangesBehavior            = require('fukit').EnableOnlyOnUnsavedChangesBehavior,
      InvokeModelMethodOnPressBehavior              = require('fukit').InvokeModelMethodOnEventBehavior,
      ShowModalOnNavigateWithUnsavedChangesBehavior = require('fukit').ShowModalOnNavigateWithUnsavedChangesBehavior,
      ModelLockBehavior                             = require('behavior/model.lock.behavior'),
      LockModel                                     = require('model/lock.model'),
      UpdateCssValuesOnPageResizeBehavior           = require('fukit').UpdateCssValuesOnPageResizeBehavior;

  var TemplateDetailPageView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.ThreeColumnLayoutView,

        className: 'form-design',

        behaviors: {
          DesignFormRootBehavior: {
            form: '@this.form',
            behaviorClass: FormKit.Block.DesignFormRootBehavior,
          },
          ModelLockBehavior: {
            model: '@resources.templateMeta',
            lockModelClass: LockModel,
            userIdAttribute: 'ownerUserId',
            fallbackRoute: 'template:list',
            modalOptions: {
              actions: {
                previewButton: {
                  visible: true,
                  behaviors: {
                    ResolveRouteBehavior: {
                      route: 'template:preview',
                      params: {
                        templateId: '@state.primaryId',
                      },
                      behaviorClass: BlocKit.ResolveRouteBehavior,
                    },
                  },
                },
              },
            },
            behaviorClass: ModelLockBehavior,
          },
        },

        pageHeader: {
          header: {
            text: 'Form Builder',
          },
          breadcrumbs: [
            { text: 'Forms', route: 'template:list' },
            {
              model: '@resources.revision',
              bindings: { text: 'template.name' },
            },
          ],
          resourceErrorsOptions: {
            useFieldValidationMessages: true,
          },
          behaviors: {
            UpdateCssValuesOnPageResizeBehavior: {
              cssValues: {
                top: {
                  selector: '#app-header > .ui.menu',
                  formatter: function($el) {
                    return $el.outerHeight(true) + 'px';
                  },
                },
              },
              behaviorClass: UpdateCssValuesOnPageResizeBehavior,
            },
          },
          actions: [
            {
              text: 'Export',
              model: '@resources.revision',
              icon: 'download',
              showLoading: true,
              id: 'ExportTemplate',
              behaviors: {
                EnableOnlyOnUnsavedChangesBehavior: {
                  invert: true,
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
              },
              onPress: function(event) {
                $('#ExportTemplate').addClass('disabled');
                window.setTimeout(function() {
                  var jsonData = JSON.stringify(event.model.options.model.attributes.json);
                  var templateData = JSON.stringify(event.model.options.model.attributes.template)
                  var exportData = [
                     jsonData ,
                    templateData 
                ];
                  var blob = new Blob([JSON.stringify(exportData)], { type: 'application/json' });
                  var a = document.createElement('a');
                  a.style.display = 'none';
                  a.download = `${event.model.options.model.attributes.template.name}.etemplate`;
                  var url = window.URL.createObjectURL(blob);
                  a.href = url;
                  document.body.appendChild(a);
                  a.click();
                  a = null;
                  $('#ExportTemplate').removeClass('disabled');
                }, 1000);
              },
            },
            {
              text: 'Preview',
              icon: 'eye',
              route: 'template:preview',
              model: '@resources.revision',
              params: { templateId: '@state.primaryId', revisionId: '@state.revisionId' },
              behaviors: {
                EnableOnlyOnUnsavedChangesBehavior: {
                  invert: true,
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
              },
            },
            {
              text: 'Publish',
              icon: 'cloud upload',
              model: '@resources.revision',
              behaviors: {
                ConfirmInvokeModelMethodOnEventBehavior: {
                  method: 'publish',
                  onMethodSuccessEvent: 'published:template',
                  onMethodSuccess: function(response) {
                    if (response.status !== 500) {
                      _.defer(function() {
                        Radio.request(
                          'notificationService',
                          'showNotification',
                          'Your form has been successfully published.'
                        );
                      });
                    }
                  },
                  showLoading: true,
                  modalOptions: {
                    header: {
                      text: 'Publish Form',
                    },
                    content: {
                      icon: 'cloud upload',
                      text: 'Are you sure you want to publish this form revision?',
                    },
                  },
                  behaviorClass: BlocKit.ConfirmInvokeModelMethodOnEventBehavior,
                },
                EnableOnlyOnUnsavedChangesBehavior: {
                  invert: true,
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
              },
            },
            {
              text: 'Revisions',
              icon: 'history',
              model: '@resources.revision',
              route: 'template:history',
              params: { templateId: '@state.primaryId', revisionId: '@state.revisionId' },
              behaviors: {
                EnableOnlyOnUnsavedChangesBehavior: {
                  invert: true,
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
              },
            },
            {
              color: 'primary',
              text: 'Save',
              icon: 'save',
              model: '@resources.revision',
              behaviors: {
                EnableOnlyOnUnsavedChangesBehavior: {
                  behaviorClass: EnableOnlyOnUnsavedChangesBehavior,
                },
                InvokeModelMethodOnPressBehavior: {
                  method: 'save',
                  showLoading: true,
                  behaviorClass: InvokeModelMethodOnPressBehavior,
                },
                ShowModalOnNavigateWithUnsavedChangesBehavior: {
                  behaviorClass: ShowModalOnNavigateWithUnsavedChangesBehavior,
                },
              },
            },
          ],
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.ContentRightTextHeaderView,
              header: {
                behaviors: {
                  BindAndFormatOptionValuesBehavior: {
                    optionValues: {
                      text: {
                        modelAttribute: 'template.name',
                      },
                    },
                    model: '@resources.revision',
                    behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  },
                },
              },
              rightText: {
                behaviors: {
                  BindAndFormatOptionValuesBehavior: {
                    optionValues: {
                      text: {
                        modelAttribute: 'number',
                        formatter: BlocKit.Formatter.prepend('Revision '),
                      },
                    },
                    model: '@resources.revision',
                    behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  },
                },
              },
            },
            {
              type: FormKit.Block.DesignSectionHeaderView,
              form: '@this.form',
            },
            {
              type: FormKit.Block.DesignFormObjectCollectionView,
              form: '@this.form',
            },
          ],
        },

        leftColumn: {
          components: [
            {
              type: FormKit.Block.DesignSectionMenuView,
              form: '@this.form',
            },
          ],
        },

        rightColumn: {
          behaviors: {
            UpdateCssValuesOnPageResizeBehavior: {
              cssValues: {
                'overflow-y': {
                  selector: ['body', '.page.header', '#app-header > .ui.menu'],
                  formatter: function($body, $pageHeader, $appHeader) {
                    var sidebarHeight = this.view.$el.outerHeight(true);
                    var roomForSidebar =
                      $body.outerHeight(true) - $pageHeader.outerHeight(true) - $appHeader.outerHeight(true);

                    if (sidebarHeight > roomForSidebar) {
                      return 'scroll';
                    } else {
                      return '';
                    }
                  },
                },
                height: {
                  selector: ['body', '.page.header', '#app-header > .ui.menu'],
                  formatter: function($body, $pageHeader, $appHeader) {
                    var sidebarHeight = this.view.$el.outerHeight(true);
                    var roomForSidebar =
                      $body.outerHeight(true) - $pageHeader.outerHeight(true) - $appHeader.outerHeight(true);

                    if (sidebarHeight > roomForSidebar) {
                      return roomForSidebar + 'px';
                    } else {
                      return '';
                    }
                  },
                },
              },
              targetElementIsParent: true,
              behaviorClass: UpdateCssValuesOnPageResizeBehavior,
            },
            ChangeSortOrderBehavior: {
              form: '@this.form',
              behaviorClass: Mn.Behavior.extend({
                initialize: function() {
                  var form = this.getOption('form');
                  var group = form.getTemplateObjectTypeGroupCollection();
                  group.on('reset', this.changeSortOrder.bind(this, group));
                },
                changeSortOrder: function(group) {
                  if (group.length) {
                    group.find({ name: 'COI Objects' }).set('sortIndex', 0);
                    group.find({ name: 'Objects' }).set('sortIndex', 1);
                    group.find({ name: 'Finders' }).set('sortIndex', 2);
                    group.sort();
                  }
                },
              }),
            },
          },
          components: [
            {
              type: FormKit.Block.DesignFormObjectMenuView,
              form: '@this.form',
            },
          ],
        },
      },
    },
  });

  module.exports = TemplateDetailPageView;
});

